import { computed, type ComputedRef } from 'vue';
import type { Options } from 'highcharts';

type BacklogOpenByWorkstreamsSeriesData = ({
    type: 'column';
    name: string;
    data: number[][];
})[];

type BacklogOpenByWorkstreamsCategoriesAndSeriesData = {
    xAxisCategories: string[];
    chartSeries: BacklogOpenByWorkstreamsSeriesData;
}

type BacklogInOutAttrByWorkstreamsSeriesData = ({
    type: 'line' | 'column';
    name: string;
    yAxis: string;
    color: string;
    data: number[][];
})[];

type BacklogInOutAttrByWorkstreamsCategoriesAndSeriesData = {
    xAxisCategories: string[];
    chartSeries: BacklogInOutAttrByWorkstreamsSeriesData;
}

export function useBLAnalysisChartConfigs(
    backlogOpenByWorkstreamsSeries: ComputedRef<BacklogOpenByWorkstreamsCategoriesAndSeriesData>,
    backlogInOutAttrByWorkstreamSeries: ComputedRef<BacklogInOutAttrByWorkstreamsCategoriesAndSeriesData>
) {

    // add `tooltip: SHARED_TOOLTIP_CHART_OPTION,` to chartOption to share tooltip with different series
    const SHARED_TOOLTIP_CHART_OPTION = {
        enabled: true,
        shared: true
    };

    const backlogOpenByWorkstreamChartOptions = computed(() => ({
        title: { text: '' },
        tooltip: SHARED_TOOLTIP_CHART_OPTION,
        xAxis: { categories: backlogOpenByWorkstreamsSeries.value.xAxisCategories },
        yAxis: { title: { text: 'Number of Open Workstreams' } },
        plotOptions: {
            series: {
                stacking: 'normal',
                dataLabels: { enabled: true }
            }
        },
        series: backlogOpenByWorkstreamsSeries.value.chartSeries,
        credits: { enabled: false }
    } as Partial<Options>));

    const backlogInOutAttrByWorkstreamChartOptions = computed(() => ({
        title: { text: '' },
        tooltip: SHARED_TOOLTIP_CHART_OPTION,
        xAxis: { categories: backlogInOutAttrByWorkstreamSeries.value.xAxisCategories },
        yAxis: [
            {
                id: 'yaxis-left',
                allowDecimals: false,
                title: { text: 'Number of Open Workstreams' }
                // labels: { style: { color: '#80a3ca' } }
            },
            {
                id: 'yaxis-right',
                allowDecimals: false,
                opposite: true,
                title: { text: 'Average Time to Resolution (hour)' },
                labels: { style: { color: '#000000' } }
            }
        ],
        series: backlogInOutAttrByWorkstreamSeries.value.chartSeries,
        credits: { enabled: false }
    } as Partial<Options>));

    return {
        backlogOpenByWorkstreamChartOptions,
        backlogInOutAttrByWorkstreamChartOptions
    };
}
